export const SETUP_FROM_DATA = 'setupFromData';
export const UPDATE_CLIENT_DATA = 'updateClientData';
export const SET_EMAILS = 'setEmails';
export const DELETE_EMAIL = 'deleteEmail';
export const SET_LOCALE = 'setLocale';
export const SIGN_OUT = 'signOut';
export const LOAD_COUNTRIES = 'loadCountries';
export const LAST_TOKEN_UPDATE = 'lastTokenUpdate';
export const REMEMBER_ME = 'rememberMe';
